import { createReducer, on } from '@ngrx/store';
import { IDashboardMessagesState } from './dashboard-messages.state';
import {
  loadWelcomeMessages,
  loadWelcomeMessagesFailure,
  loadWelcomeMessagesSuccess,
} from './dashboard-messages.actions';

export const initialState: IDashboardMessagesState = {
  messages: [],
  loading: false,
  loaded: false,
  error: false,
};

export const dashboardMessagesReducer = createReducer(
  initialState,
  on(loadWelcomeMessages, (state) => ({
    ...state,
    loading: true,
    error: false,
  })),
  on(loadWelcomeMessagesSuccess, (state, { messages }) => ({
    ...state,
    messages,
    loading: false,
    loaded: true,
  })),
  on(loadWelcomeMessagesFailure, (state) => ({
    ...state,
    messages: [],
    loading: false,
    loaded: true,
    error: true,
  }))
);
